
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";





const AccountsHeader = ({ basePath = "/admin/dashboard/account", showUpdatePassword = true }) => {

    const { pathname } = useLocation();
    const { isRoot } = useSelector((state) => state.auth);
    const contactPath = `${basePath}/contact`;
    const updatePasswordPath = `${basePath}/update-password`;
    const loginConfigPath = `${basePath}/api-limiting`;

    return <div className="d-flex">
        <div className="section_sub_heading">
            <Link className={pathname === contactPath ? "active" : ""} to={contactPath}>Contact</Link>
        </div>
        {/* <div className="section_sub_heading">
                    <Link className={pathname === "/admin/dashboard/account/billing" ? "active" : ""} to="/admin/dashboard/account/billing">Billing</Link>
                </div> */}
        {showUpdatePassword ? (<div className="section_sub_heading">
            <Link className={pathname === updatePasswordPath ? "active" : ""} to={updatePasswordPath}>Update Password</Link>
        </div>) : ""}
        {isRoot ? (<div className="section_sub_heading">
            <Link className={pathname === loginConfigPath ? "active" : ""} to={loginConfigPath}>Login Configuration</Link>
        </div>) : ""}
    </div>;

}

export default AccountsHeader;